// extracted by mini-css-extract-plugin
export default {"root":"_36ucy","icon":"_3EBVF","title":"_3zKnK","subtitle":"d_vx6","button":"_3ZNVf"};